import Rover from '@rover/globals/Rover';
import getUrlParameter from '@rover/utilities/getUrlParameter';

import { addEventParamsToUrl } from './url.server';

export { addEventParamsToUrl, getEventParamsFromUrl } from './url.server';
export { default as getQueryParams } from '@rover/utilities/getQueryParams';

const OPEN_TARGETS = ['_blank', '_self', '_parent', '_top'] as const;
const REPLACE_TARGET = '_replace' as const;

type AllowableTargets = (typeof OPEN_TARGETS)[number] | typeof REPLACE_TARGET;

Rover.utils = Rover.utils || {};
Rover.utils.getUrlParameter = getUrlParameter;

Rover.utils.hasHashParam = (name: string): boolean => {
  if (window.location.hash) {
    const hash = window.location.hash.substring(1);

    if (hash.indexOf(name) !== -1) {
      return true;
    }
  }

  return false;
};

export function redirect(url: string | Location | URL, target?: AllowableTargets): void {
  const finalURL = url instanceof URL || url instanceof Location ? url.toString() : url;
  if (target === REPLACE_TARGET) {
    /** `replace` navigates the user without adding to the browser's history */
    window.location.replace(finalURL);
  } else if (target && OPEN_TARGETS.includes(target)) {
    window.open(finalURL, target);
  } else {
    // `window` is also `typeof globalThis`, which doesn't allow setting `location` to a string
    // https://github.com/microsoft/TypeScript/issues/48949
    (window as Window).location.href = finalURL;
  }
}

// Our types for `URLSearchParams` are incorrect – it does implement Symbol.iterator
declare global {
  interface URLSearchParams {
    entries(): IterableIterator<[string, string]>;
    [Symbol.iterator](): IterableIterator<[string, string]>;
  }
}

declare global {
  interface Window {
    isRoverURL(url: string): boolean;
  }
}

window.isRoverURL = (url: string): boolean =>
  url.indexOf('//') === -1 ||
  url.indexOf(Rover.urls.base) !== -1 ||
  url.indexOf('//localhost') !== -1 ||
  url.indexOf('//0.0.0.0') !== -1 ||
  url.indexOf('//127.0.0.1') !== -1;

export default { ...Rover.utils, redirect, addEventParamsToUrl };
